module.exports = __webpack_public_path__ + "static/media/v_empty_list.70f1253b.jpg";